import { useMemo } from 'react';
import { DashboardPrice } from '../../../types/types';
import { G_N_COLORS } from '../../../utils/prices';
import { DashboardTariffHours } from '../tariff-hours';

export const G11Hours: React.FC = () => {
  const g11Prices: DashboardPrice[] = useMemo(() => {
    const currentHour = new Date().getHours();
    const prices = Array.from({ length: 24 }, (_, i) => i);

    const dashboardPrices: DashboardPrice[] = [...prices]
      .sort((a, b) => {
        const ah = (a - currentHour + 24) % 24;
        const bh = (b - currentHour + 24) % 24;
        return ah - bh;
      })
      .map((x) => ({
        startingHour: x,
        color: G_N_COLORS[2],
      }));

    return dashboardPrices;
  }, []);

  return <DashboardTariffHours prices={g11Prices} />;
};
